import { makeAutoObservable } from 'mobx'
import { type IFilterValue } from 'widgets/FilterEditor/types/types'

export class HubspotControl {
  private _initialLoading = true
  private _itemsMap = new Map<string, IFilterValue>()
  private _selectedMap = new Map<string, IFilterValue>()

  constructor() {
    makeAutoObservable(this)
  }

  get initialLoading() {
    return this._initialLoading
  }

  get selectedItems() {
    return Array.from(this._selectedMap.values())
  }

  isSelected = (key: number | string) => this._selectedMap.has(String(key))

  toggleItem = (key: number | string) => {
    const value = String(key)

    if (this._selectedMap.has(value)) {
      this._selectedMap.delete(value)
    } else {
      const item = this._itemsMap.get(value)
      item && this._selectedMap.set(String(item.key), item)
    }
  }

  setFilterValues = (items: IFilterValue[]) => {
    items.forEach((item) => {
      this._itemsMap.set(String(item.key), item)
    })
  }

  syncActiveItems = (keys: Array<string | number>) => {
    keys.forEach((key) => {
      const item = this._itemsMap.get(String(key))
      item && this._selectedMap.set(String(item.key), item)
    })

    this._initialLoading = false
  }

  clearSelection = () => {
    this._selectedMap.clear()
  }

  reset = () => {
    this._initialLoading = true
    this._itemsMap.clear()
    this._selectedMap.clear()
  }
}
